import { FetchErrorType } from '../../../types/common/fetch-error-type';
import { FetchResultType } from '../../../types/common/fetch-result';
import { errorResponseConverterGenerator } from './fetch/error-response-converter-generator';
import { fetchJsonWithTokenCheck } from './fetch/fetch-json-with-token-check';
import { mapFetchResult } from './fetch/map-fetch-result';
import { HttpMethod } from './fetch/types/enum/http-method';

/* made to avoid syntax highlight error */
type ResultType<S, E> = FetchResultType<S, FetchErrorType<E>>;

export const fetchWithBodyTemplateFn = (
  httpMethod: ('POST' | 'PUT' | 'PATCH') & HttpMethod
) => <
  RequestBodyType,
  RawRequestBodyType extends object,
  RawSuccessResponseType extends object,
  SuccessResponseType,
  RawErrorResponseType extends object,
  ErrorResponseType
>(
  token: string,
  uri: string,
  requestBodyConverter: (v: RequestBodyType) => RawRequestBodyType,
  successResponseConverter: (v: RawSuccessResponseType) => SuccessResponseType,
  errorResponseConverter: (v: RawErrorResponseType) => ErrorResponseType
) => async (
  body: RequestBodyType
): Promise<ResultType<SuccessResponseType, ErrorResponseType>> => {
  const result = await fetchJsonWithTokenCheck({
    token,
    uri,
    method: httpMethod,
    body: requestBodyConverter(body)
  });

  return mapFetchResult(
    result as FetchResultType<RawSuccessResponseType, RawErrorResponseType>,
    successResponseConverter,
    errorResponseConverterGenerator(errorResponseConverter)
  );
};
